import { RootState } from 'store';

const TaskTypesLookupState = (state: RootState) => state.lookups.taskTypes;
export const selectTaskTypes = (state: RootState) => TaskTypesLookupState(state).rows;
